var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0501 2.71659L12.7834 1.98325C13.6501 1.11659 15.1584 1.11659 16.0251 1.98325L16.6167 2.57492C17.0501 3.00825 17.2917 3.58325 17.2917 4.19159C17.2917 4.79992 17.0501 5.38325 16.6167 5.80825L15.8834 6.54159L12.0501 2.70825V2.71659ZM11.1667 3.59992L3.57508 11.1916C3.33341 11.4333 3.18341 11.7499 3.15841 12.0916L2.93341 14.5333C2.90841 14.8416 3.01675 15.1416 3.23341 15.3666C3.43341 15.5666 3.69175 15.6749 3.96675 15.6749H4.05841L6.50008 15.4499C6.84175 15.4166 7.15841 15.2666 7.40008 15.0249L14.9917 7.43325L11.1584 3.59992H11.1667ZM18.9584 18.3333C18.9584 17.9916 18.6751 17.7083 18.3334 17.7083H1.66675C1.32508 17.7083 1.04175 17.9916 1.04175 18.3333C1.04175 18.6749 1.32508 18.9583 1.66675 18.9583H18.3334C18.6751 18.9583 18.9584 18.6749 18.9584 18.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.521b7befcd53fb60f994a5f4db20a883.svg";
export { ForwardRef as ReactComponent };